export default "__VITE_ASSET__H35zTbiX__"